export const profiles = [
    {
        label: 'Pioneer (1)',
        key: 'pioneer'
    },
    {
        label: 'Influencer (2)',
        key: 'influencer'
    },
    {
        label: 'Team Player (3)',
        key: 'teamPlayer'
    },
    {
        label: 'Logical Thinker (4)',
        key: 'logicalThinker'
    },
    {
        label: 'Persuader (5)',
        key: 'persuader'
    },
    {
        label: 'Achiever (6)',
        key: 'achiever'
    },
    {
        label: 'Perfectionist (7)',
        key: 'perfectionist'
    },
    {
        label: 'Collaborator (8)',
        key: 'collaborator'
    },
    {
        label: 'Accessor (9)',
        key: 'assessor'
    },
    {
        label: 'Implementor (10)',
        key: 'implementor'
    },
    {
        label: 'Motivator (11)',
        key: 'motivator'
    },
    {
        label: 'Leader (12)',
        key: 'leader'
    },
    {
        label: 'Administrator (13)',
        key: 'administrator'
    },
    {
        label: 'Mediator (14)',
        key: 'mediator'
    }, {
        label: 'All Rounder (15)',
        key: 'allRounder'
    }
]